import PropTypes from 'prop-types';

const Dictionary = {
  id: PropTypes.number,
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export const DictionaryShape = PropTypes.shape(Dictionary);
export const DictionaryExact = PropTypes.exact(Dictionary);
